const STEP_LABELS = ["Conta", "Organização"];

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export default function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
  return (
    <div className="mb-10 px-2">
      <div className="flex items-start justify-center max-w-md mx-auto">
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
          <div key={step} className="flex items-center flex-1 min-w-0">
            <div className="flex flex-col items-center gap-2 w-full max-w-[100px] mx-auto">
              <div
                className={`rounded-full h-11 w-11 flex items-center justify-center text-sm font-semibold transition-all shadow-sm shrink-0 ${
                  currentStep === step
                    ? "bg-primary text-primary-foreground scale-105 ring-4 ring-primary/20"
                    : currentStep > step
                      ? "bg-primary text-primary-foreground"
                      : "bg-muted text-muted-foreground"
                }`}
                aria-current={currentStep === step ? "step" : undefined}
              >
                {currentStep > step ? "✓" : step}
              </div>
              <span
                className={`text-[11px] sm:text-xs font-medium text-center leading-tight px-1 ${
                  currentStep === step ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {STEP_LABELS[step - 1]}
              </span>
            </div>
            {step < totalSteps && (
              <div
                className={`h-[3px] flex-1 min-w-[24px] rounded-full mt-[18px] mx-1 transition-colors ${
                  currentStep > step ? "bg-primary/70" : "bg-border"
                }`}
                aria-hidden
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
